export enum SessionType {
  'Video on Demand' = 'Video on Demand',
  'Personal Training' = 'Personal Training', // LIVE 1:1
  'Planned Session' = 'Planned Session', // Custom session
  'Free Forme' = 'Free Forme', // Solo session - Lift
}
